import React from 'react';
import PropTypes from 'prop-types';

import {
    Flex, Text, TextButton,
} from '@zillow/constellation';
import { Center } from '@zillow/zrs-comet';

import { AddPropertyModal } from 'app/shared/components/Modal';

const propTypes = {
    isAddPropertyModalOpen: PropTypes.bool.isRequired,
};

const NothingToTransfer = ({ isAddPropertyModalOpen, onFindListingsClick }) => (
    <Flex display="flex" flexDirection="column" alignItems="center" marginY="sm">
        <Center mediaQuery={{ lg: { marginX: '12' } }}>
            <Text>
                All listings for these contact methods have been already transferred.
                To transfer more listings, search by other contact methods.
            </Text>
        </Center>
        <TextButton onClick={onFindListingsClick}>Find listings</TextButton>
        {isAddPropertyModalOpen && (<AddPropertyModal isOpen={isAddPropertyModalOpen} />)}
    </Flex>
);

NothingToTransfer.propTypes = propTypes;

export default NothingToTransfer;
